import './collectiontitle.less'

import {DOMAttrs, m, StatelessView, style} from '@codeurs/front'
import Title from './title'

export const CollectionTitle: StatelessView<DOMAttrs> = ({
	children,
	...attrs
}) => m(style(Title, '.collectiontitle'), {heading: 2, ...attrs}, children)
